/**
 * DATE DE LIVRAISON ESTIMÉE — fiche produit (bloc « Date de livraison estimée »)
 * --------------------------------------------------------------------------
 * <delivery-estimate data-cutoff="11:00" data-transit="2" data-saturday="false"
 *                    data-holidays="2026-12-25,…" data-locale="fr" data-template="Livré chez vous __DATE__">
 *
 * Calcul fait dans le NAVIGATEUR (les pages Shopify sont en cache → l'heure côté
 * serveur serait fausse), à l'heure de Paris (entrepôt) :
 *  1. expédition = aujourd'hui si jour ouvré (lun-ven, hors fériés) ET avant l'heure
 *     limite ; sinon le prochain jour ouvré ;
 *  2. livraison = expédition + N jours de livraison (lun-ven, + samedi si activé,
 *     hors fériés).
 * Élément personnalisé → recalculé à chaque insertion (re-rendu au changement de
 * variante). Reste masqué tant que rien n'est calculé (pas de ligne vide).
 */
(function () {
  if (window.customElements.get('delivery-estimate')) return;

  var TZ = 'Europe/Paris';

  // Date « calendaire » de Paris (UTC midi pour éviter les décalages d'heure d'été)
  function parisNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });

    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12)),
      minutes: (+parts.hour) * 60 + (+parts.minute)
    };
  }

  function iso(d) {
    return d.toISOString().slice(0, 10);
  }

  function addDays(d, n) {
    return new Date(d.getTime() + n * 86400000);
  }

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      try {
        this.render();
      } catch (e) {
        this.hidden = true;
      }
    }

    render() {
      var transit = parseInt(this.dataset.transit, 10);
      if (isNaN(transit) || transit < 0) return;

      var cutoff = (this.dataset.cutoff || '11:00').split(':');
      var cutoffMinutes = (+cutoff[0]) * 60 + (+cutoff[1] || 0);
      var saturday = this.dataset.saturday === 'true';
      var holidays = {};
      (this.dataset.holidays || '').split(',').forEach(function (h) {
        h = h.trim();
        if (h) holidays[h] = true;
      });

      function isShippingDay(d) {
        var dow = d.getUTCDay();
        return dow >= 1 && dow <= 5 && !holidays[iso(d)];
      }
      function isDeliveryDay(d) {
        var dow = d.getUTCDay();
        return (dow >= 1 && dow <= 5 || (saturday && dow === 6)) && !holidays[iso(d)];
      }

      var now = parisNow();

      // 1. Jour d'expédition
      var ship = now.date;
      if (!(isShippingDay(ship) && now.minutes < cutoffMinutes)) {
        do { ship = addDays(ship, 1); } while (!isShippingDay(ship));
      }

      // 2. Jour de livraison
      var delivery = ship;
      var left = transit;
      while (left > 0) {
        delivery = addDays(delivery, 1);
        if (isDeliveryDay(delivery)) left--;
      }

      var formatted = new Intl.DateTimeFormat(this.dataset.locale || document.documentElement.lang || 'fr', {
        timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
      }).format(delivery);

      this.localizeCutoff(cutoff);

      var text = this.querySelector('.delivery-estimate__text');
      if (!text) return;
      // marqueur __DATE__ (pas d'accolades : un « } » dans une chaîne casse la balise {{ }} côté Shopify)
      // la date est isolée dans un <strong> (graisse Medium, delivery-estimate.css) ; texte posé via
      // textContent (pas d'innerHTML : la traduction reste du texte brut)
      var parts = (this.dataset.template || '__DATE__').split('__DATE__');
      var date = document.createElement('strong');
      date.className = 'delivery-estimate__date';
      date.textContent = formatted;
      text.textContent = '';
      text.append(parts[0], date, parts.slice(1).join(formatted));
      this.hidden = false;
    }
  }

  // Heure limite (définie en heure de Paris) affichée dans le FUSEAU DU VISITEUR :
  // pas besoin de préciser « heure de Paris » (même heure pour la France, la Belgique,
  // l'Allemagne… ; 1 h de moins au Royaume-Uni / Portugal / Irlande).
  DeliveryEstimate.prototype.localizeCutoff = function (cutoff) {
    var span = this.querySelector('.delivery-estimate__cutoff');
    if (!span) return;

    // Décalage actuel de Paris par rapport à UTC (heure d'été comprise)
    var now = new Date();
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    var parisAsUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute);
    var offset = parisAsUtc - Math.floor(now.getTime() / 60000) * 60000;

    var cutoffUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +cutoff[0], +cutoff[1] || 0) - offset;
    var local = new Date(cutoffUtc);
    var locale = this.dataset.locale || document.documentElement.lang || 'fr';

    if (/^fr/i.test(locale)) {
      var m = local.getMinutes();
      span.textContent = local.getHours() + 'h' + (m ? String(m).padStart(2, '0') : '');
    } else {
      span.textContent = new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit' }).format(local)
        + (/^de/i.test(locale) ? ' Uhr' : '');
    }
  };

  window.customElements.define('delivery-estimate', DeliveryEstimate);

  // Info-bulle « i » : tap (mobile) = ouvre/ferme ; tap ailleurs ou Échap = ferme.
  // (Au survol sur ordinateur, l'affichage est géré en CSS.)
  function closeTips(except) {
    document.querySelectorAll('delivery-estimate.is-tip-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-tip-open');
      var btn = el.querySelector('.delivery-estimate__info');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.delivery-estimate__info');
    if (!btn) { closeTips(null); return; }
    var host = btn.closest('delivery-estimate');
    if (!host) return;
    var open = !host.classList.contains('is-tip-open');
    closeTips(host);
    host.classList.toggle('is-tip-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeTips(null);
  });
})();
